import { useContext } from 'react';
import { addOrRemoveFromArray } from '#shared/utils';
import { TreeTagsFilterContext } from './context';

export const useTreeTagsSearch = () => {
  const context = useContext(TreeTagsFilterContext);

  if (!context) {
    throw new Error(
      'useTreeTagsSearch must be used within a TreeTagsSearchProvider'
    );
  }

  const { setSelectedIds, ...rest } = context;

  const reset = () => {
    setSelectedIds([]);
  };

  const setSelectedId = (tagId: string) => {
    setSelectedIds(prev => {
      return addOrRemoveFromArray(prev, tagId);
    });
  };

  return {
    reset,
    setSelectedId,
    setSelectedIds,
    ...rest
  };
};
